import { WorkoutSelection, WorkoutSettings } from '../../entities';

export class WorkoutSelectionSerializer {
    public static deserializeWorkoutSelection(doc: any): WorkoutSelection {
        const settings: WorkoutSettings = doc.settings;
        const returnObject = Object.assign(
            new WorkoutSelection(
                doc.workoutSequenceDate,
                settings.cardioOrResistance,
                settings.allowBagContact,
                settings.level,
                settings.threeBodyGroups,
                doc.exerciseSelections,
                doc.gymType,
                settings.equipment,
        ), doc);

        return returnObject;
    }

    public static serializeWorkoutSelection(
        workoutSelection: WorkoutSelection, overridingRevNumber?: string): any {
        WorkoutSelectionSerializer.shrinkExerciseToOnlyRefnr(workoutSelection);
        const doc = JSON.parse(JSON.stringify(workoutSelection));
        doc._id = workoutSelection.uniqueReference;
        if (overridingRevNumber != null) {
            doc._rev = overridingRevNumber;
        }
        return doc;
    }

    private static shrinkExerciseToOnlyRefnr(workoutSelection: WorkoutSelection) {
        for (const exerciseSelection of workoutSelection.exerciseSelections) {
            if (exerciseSelection.exercise != null) {
                const exRef = exerciseSelection.exercise.uniqueReferenceNumber;
                const ex: any = { uniqueReferenceNumber: exRef };
                exerciseSelection.exercise = ex;
            }
            if (exerciseSelection.alternateExercise != null) {
                const exRef = exerciseSelection.alternateExercise.uniqueReferenceNumber;
                const ex: any = { uniqueReferenceNumber: exRef };
                exerciseSelection.alternateExercise = ex;
            }
            if (exerciseSelection.secondAlternateExercise != null) {
                const exRef = exerciseSelection.secondAlternateExercise.uniqueReferenceNumber;
                const ex: any = { uniqueReferenceNumber: exRef };
                exerciseSelection.secondAlternateExercise = ex;
            }
            if (exerciseSelection.thirdAlternateExercise != null) {
                const exRef = exerciseSelection.thirdAlternateExercise.uniqueReferenceNumber;
                const ex: any = { uniqueReferenceNumber: exRef };
                exerciseSelection.thirdAlternateExercise = ex;
            }
        }
    }
}
